var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileArt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 300",
    width: 406,
    height: 306,
    className: "illustration styles_illustrationTablet__1DWOa",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_63_user_interface",
    "data-name": "#63_user_interface"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 135.62,
    y: 43.61,
    width: 186.65,
    height: 181.17,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.27,43.61V224.79H135.62V43.61H322.27m0-.91H135.62a.91.91,0,0,0-.91.91V224.79a.91.91,0,0,0,.91.91H322.27a.91.91,0,0,0,.91-.91V43.61a.91.91,0,0,0-.91-.91Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.7,
    y: 66.13,
    width: 44.67,
    height: 3.27,
    rx: 1.09,
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.1,
    y: 81.61,
    width: 16.72,
    height: 18.83,
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.68,
    y: 83.01,
    width: 84.84,
    height: 4.93,
    rx: 2.46,
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.68,
    y: 92.43,
    width: 59.55,
    height: 4.93,
    rx: 2.46,
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.1,
    y: 160.03,
    width: 16.72,
    height: 18.83,
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.68,
    y: 161.44,
    width: 84.84,
    height: 4.93,
    rx: 2.46,
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.68,
    y: 170.85,
    width: 59.55,
    height: 4.93,
    rx: 2.46,
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.1,
    y: 189.24,
    width: 16.72,
    height: 18.83,
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.68,
    y: 190.65,
    width: 84.84,
    height: 4.93,
    rx: 2.46,
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.68,
    y: 200.06,
    width: 59.55,
    height: 4.93,
    rx: 2.46,
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 143.16,
    cy: 49.96,
    r: 2,
    fill: "#FF663B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.16,
    cy: 49.96,
    r: 2,
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 157.16,
    cy: 49.96,
    r: 2,
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.82,
    y: 56.32,
    width: 1,
    height: 168.47,
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.62,
    y: 55.82,
    width: 186.65,
    height: 1,
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.45,245.82H67.12a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5H348.45a.5.5,0,0,1,.5.5A.51.51,0,0,1,348.45,245.82Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.89,193.28a9.87,9.87,0,0,0-1.13-5.33,39.12,39.12,0,0,1-2.4-3.38c-1-2.17-.3-4.71-.54-7.09a8.83,8.83,0,0,0-2.49-5.29c-1.25-1.26-2.85-2.12-4-3.43-2-2.16-2.51-5.18-3.61-7.87a19.67,19.67,0,0,0-7.79-9.16c2.12,4.27-2.72,9.7-.53,13.94.7,1.35,2,2.33,2.54,3.75,1.23,3.44-2.87,7.17-1.56,10.57.65,1.71,2.48,2.69,3.33,4.31,1.14,2.18.24,4.82.34,7.28.12,3.39,2.19,6.42,4.64,8.77,1.53,1.46,3.23,2.73,4.88,4.05,2,1.58,2.8,3.24,4.54.7A21.82,21.82,0,0,0,317.89,193.28Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.09,195.22c-.63-2.62-1.08-5.47,0-7.94,1.21-2.8,4.23-4.78,4.58-7.81.23-2-.78-4-.38-6s2-3.29,3.32-4.74a19.84,19.84,0,0,0,5.12-12.12,30.15,30.15,0,0,1,4.88,8.06c1,3,1.06,6.49-.71,9.1a8.2,8.2,0,0,0-1.24,2c-.59,1.93,1.06,3.73,1.91,5.56A6.4,6.4,0,0,1,337,188c-1.73,2.16-5.08,3-5.93,5.64a13.49,13.49,0,0,0-.3,3,8.77,8.77,0,0,1-6.31,7.53c-2.05.49-2-.32-2.38-2C321.54,199.78,320.65,197.54,320.09,195.22Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.56,176.35c-1.45-5-2-10.31-3.57-15.32a85.12,85.12,0,0,0-4.77-11.43l6.25,2.64c2,.84,4.17,1.84,5.12,3.8,1.65,3.41-1.31,7.78.42,11.15a28.08,28.08,0,0,0,2.47,3.11c1.84,2.59,1.56,6.14.55,9.15-.43,1.29-2.33,8-4,6.13-.68-.75-.74-3.52-1-4.54C314.55,179.47,314,177.92,313.56,176.35Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317,243.32c-1.25-8.24-5.15-37.28-5.19-37.57l1-.14c0,.29,3.94,29.33,5.19,37.56Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.41,251.1h-1c.07-9.78,4.14-47.15,6.49-49.72l.74.68C323.08,203.76,318.5,237.7,318.41,251.1Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.53,249.24l-1-.05c.93-21.09-3.54-65.4-3.59-65.84l1-.1C317,183.69,321.46,228.07,320.53,249.24Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.27,219.71h23.27l-1.63,26.44c-.28,4.57-3.67,8.12-7.75,8.12h-4.51c-4.08,0-7.47-3.55-7.75-8.12Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.16,254.79h-4.51c-4.34,0-8-3.79-8.27-8.61l-1.63-26.44a.49.49,0,0,1,.14-.38.53.53,0,0,1,.38-.16h23.27a.53.53,0,0,1,.38.16.49.49,0,0,1,.14.38l-1.63,26.44C328.13,251,324.5,254.79,320.16,254.79Zm-13.34-34.56,1.59,25.89c.26,4.28,3.45,7.63,7.24,7.63h4.51c3.79,0,7-3.35,7.24-7.63L329,220.23Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123,237.7c-.14.88.74,11.15.74,11.15s12.56,2.16,12.63,1.33,3.8-4.66,3.8-4.66l-5.06-2.36-.45-12.4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.36,250.8a97.56,97.56,0,0,1-11.69-1.5.47.47,0,0,1-.38-.42c-.09-1-.89-10.34-.74-11.25a.45.45,0,0,1,.21-.32l11.67-6.94a.45.45,0,0,1,.45,0,.49.49,0,0,1,.24.39l.43,12.11,4.82,2.25a.43.43,0,0,1,.25.33.46.46,0,0,1-.12.4c-1.69,1.74-3.58,3.91-3.68,4.39a.54.54,0,0,1-.22.38A2.48,2.48,0,0,1,135.36,250.8Zm-11.19-2.34c5.16.87,10.76,1.61,11.81,1.43a22.06,22.06,0,0,1,3.42-4.23l-4.49-2.09a.46.46,0,0,1-.26-.4l-.42-11.62L123.44,238C123.42,239.2,123.85,244.76,124.17,248.46Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "84.94 238.59 83.11 251.27 91.43 251.27 96.3 237.7 84.94 238.59",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.43,251.73H83.11a.48.48,0,0,1-.35-.16.47.47,0,0,1-.1-.36l1.83-12.69a.46.46,0,0,1,.41-.39l11.36-.89a.46.46,0,0,1,.4.18.45.45,0,0,1,.07.43l-4.87,13.58A.46.46,0,0,1,91.43,251.73Zm-7.79-.91h7.47l4.52-12.61-10.29.8Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.75,66.54a6.24,6.24,0,0,0-.85-.05A19.47,19.47,0,0,0,108,67.78c-2-1.4-4.77-1.14-7.08-.31-5.74,2-8.89,7-11.72,12.09-1.27,2.29-3.12,4.72-4.06,7.12-1.43,3.62-1.59,6.73-4.12,10-2.39,3.11-5.34,5.74-7.91,8.71-3.48,4-6.3,8.83-7,14.11-1.52,11.3,9.27,22.41,20.24,21.58s22.85-3.66,29.55-12.41c7.4-9.65,8.13-24.37,7-36-.62-6.09-.46-12.59-3.07-18.26a26.36,26.36,0,0,0-4-6.65A5,5,0,0,0,112.75,66.54Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.24,141.61a19.79,19.79,0,0,1-14-6.47,19.3,19.3,0,0,1-5.52-15.67c.65-4.81,3-9.64,7.12-14.35,1-1.22,2.19-2.4,3.29-3.55a62.64,62.64,0,0,0,4.6-5.14A18.13,18.13,0,0,0,83.6,90c.33-1.1.66-2.24,1.13-3.43a29.76,29.76,0,0,1,2.6-4.73c.54-.85,1-1.65,1.49-2.45,2.83-5.07,6.07-10.19,12-12.3,1.66-.6,4.78-1.34,7.26.21A23.84,23.84,0,0,1,111.9,66c.27,0,.59,0,.9,0h0a5.66,5.66,0,0,1,3.31,1.42,24.81,24.81,0,0,1,4.1,6.78c2.07,4.48,2.43,9.47,2.78,14.3.1,1.38.2,2.75.34,4.11.91,8.93,1.21,25.53-7,36.29-5.65,7.38-15.43,11.49-29.88,12.59C86,141.59,85.63,141.61,85.24,141.61Zm19.32-74.37a10.48,10.48,0,0,0-3.46.66c-5.6,2-8.74,7-11.48,11.89-.46.82-1,1.67-1.51,2.49a29.74,29.74,0,0,0-2.53,4.57c-.46,1.16-.78,2.27-1.1,3.35A18.79,18.79,0,0,1,81.4,97a59.9,59.9,0,0,1-4.66,5.23c-1.09,1.13-2.22,2.3-3.26,3.51-4,4.57-6.28,9.24-6.9,13.87a18.35,18.35,0,0,0,5.28,14.92c4,4.23,9.42,6.53,14.48,6.14,14.18-1.07,23.74-5.07,29.22-12.22,8.06-10.52,7.75-26.85,6.86-35.65-.14-1.36-.24-2.75-.34-4.13-.35-4.75-.7-9.66-2.7-14a24.42,24.42,0,0,0-3.92-6.52A4.73,4.73,0,0,0,112.7,67h0c-.28,0-.56,0-.8,0a27.25,27.25,0,0,0-3.54,1.15.46.46,0,0,1-.6.07h0A5.52,5.52,0,0,0,104.56,67.24Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "129.06 144.27 120.59 99.83 96.22 101.77 96.3 139.87 129.06 144.27",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.06,144.72H129l-32.76-4.4a.45.45,0,0,1-.4-.45l-.08-38.1a.46.46,0,0,1,.42-.45l24.37-1.94a.46.46,0,0,1,.49.37l8.46,44.43a.46.46,0,0,1-.11.4A.47.47,0,0,1,129.06,144.72Zm-32.3-5.25,31.73,4.26-8.27-43.41L96.67,102.2Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3,139.87s-10.23,72.21-13.19,99.36l13.11,2.06s8.94-37.74,17.4-62.17l8.13,62.17,14.62-1.89-4.53-99.53Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.72,122.58,90.6,126.9,88.41,164l17-.5L102,104.05l13.86-.55c0,.53,4.41,48.93,5.84,60.47l16.57-5.06-6.79-34.25,9.3-4.76S135,97,115.84,98.11c-17.69,1-11.51,1-11.16,1-.35,0-14,.06-20.29,8.47A66.09,66.09,0,0,0,75.72,122.58Z",
    fill: "#FF663B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.86,95.64s1.59,8.61,1.59,8.61.09,5-5.45,4.59a11.09,11.09,0,0,1-8.22-4.79q-.89-5.33-1.76-10.66c-.65-3.94-1.73-8.08-1.94-12.07,4.16,1.33,9.29-3.92,10.6-7.33a6.43,6.43,0,0,1-1.33,6.17,7.93,7.93,0,0,0,4.92-5.1,30,30,0,0,1,3.44,3.1,15.12,15.12,0,0,1,2.08,4.25c.81,2.66,1.5,6.65.15,9.23C116.19,95,113.86,95.64,113.86,95.64Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.64,109.32l-.68,0a11.46,11.46,0,0,1-8.57-5,.49.49,0,0,1-.06-.17L99.57,93.47c-.21-1.25-.45-2.51-.7-3.78a59.89,59.89,0,0,1-1.24-8.35.44.44,0,0,1,.18-.38.46.46,0,0,1,.41-.08c3.84,1.24,8.8-3.84,10-7.06a.46.46,0,0,1,.86,0,6.88,6.88,0,0,1-.42,5.17,7.49,7.49,0,0,0,3.14-4.09.48.48,0,0,1,.37-.33c.59-.1,3.85,3.26,3.88,3.29a15.32,15.32,0,0,1,2.14,4.39c.57,1.86,1.72,6.51.13,9.57a8.54,8.54,0,0,1-4,4.08c.31,1.67,1.52,8.24,1.52,8.24a5.44,5.44,0,0,1-1.54,3.84A5.21,5.21,0,0,1,110.64,109.32Zm-8.42-5.44a10.65,10.65,0,0,0,7.81,4.5,4.62,4.62,0,0,0,3.69-1,4.56,4.56,0,0,0,1.27-3.09s-1.56-8.45-1.58-8.53a.46.46,0,0,1,.33-.53s2.18-.66,3.8-3.77c1.43-2.76.34-7.13-.19-8.88a14.36,14.36,0,0,0-2-4.12c-.2-.26-2-1.94-2.84-2.65a8.39,8.39,0,0,1-5,4.81.44.44,0,0,1-.53-.18.45.45,0,0,1,0-.56,5.94,5.94,0,0,0,1.49-4.45c-1.83,3.2-6.09,7.18-9.92,6.51a64.75,64.75,0,0,0,1.18,7.6c.25,1.28.5,2.56.71,3.81Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.37,87.24a3,3,0,0,0-1.29-1.45,5.49,5.49,0,0,0-1.76-.56,2.3,2.3,0,0,0-1,0,1.66,1.66,0,0,0-.62.35,2.37,2.37,0,0,0-.93,1.36,2.65,2.65,0,0,0,.16,1.33,5.47,5.47,0,0,0,.58,1.36,3.74,3.74,0,0,0,5.19,1.12",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.64,91.74a4.1,4.1,0,0,1-3.47-1.91,6,6,0,0,1-.64-1.45,3.35,3.35,0,0,1-.16-1.53,2.69,2.69,0,0,1,1.07-1.59,2.1,2.1,0,0,1,.76-.42,2.61,2.61,0,0,1,1.18,0,6,6,0,0,1,1.9.6,3.43,3.43,0,0,1,1.46,1.64.39.39,0,0,1-.21.52.39.39,0,0,1-.52-.2,2.73,2.73,0,0,0-1.13-1.27,5,5,0,0,0-1.63-.5,1.82,1.82,0,0,0-.83,0,1.4,1.4,0,0,0-.49.28A2,2,0,0,0,95.15,87a2.43,2.43,0,0,0,.15,1.15,4.77,4.77,0,0,0,.54,1.25A3.38,3.38,0,0,0,98,90.87a3.35,3.35,0,0,0,2.52-.47.41.41,0,0,1,.56.12.4.4,0,0,1-.12.55A4.16,4.16,0,0,1,98.64,91.74Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.34,99.06s-3.35,1.68-6.07-.2a6.18,6.18,0,0,1-2.86-4.31s5.08,2.54,8.46,1.27Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.27,100.2a5.63,5.63,0,0,1-3.25-1,6.55,6.55,0,0,1-3-4.64.43.43,0,0,1,.2-.39.43.43,0,0,1,.44,0s4.94,2.43,8.1,1.24a.46.46,0,0,1,.38,0,.42.42,0,0,1,.22.31l.46,3.25a.44.44,0,0,1-.23.46A8,8,0,0,1,111.27,100.2ZM106,95.31a6.27,6.27,0,0,0,2.5,3.18c2,1.41,4.5.63,5.33.3l-.34-2.4C110.85,97.1,107.53,95.94,106,95.31Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.64,81.88s3.61,3.59,3.1,4.44-2.46.75-2.46.75",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.51,87.52h-.26a.43.43,0,0,1-.41-.46.42.42,0,0,1,.46-.42c.55,0,1.77-.06,2.06-.53,0-.41-1.36-2.24-3-3.9a.45.45,0,0,1,0-.63.44.44,0,0,1,.62,0c1.76,1.75,3.74,4,3.16,5S114.12,87.52,113.51,87.52Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 108.06,
    cy: 83.03,
    rx: 0.7,
    ry: 0.99,
    transform: "translate(-24.2 50.2) rotate(-23.59)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 115.7,
    cy: 81.66,
    rx: 0.7,
    ry: 0.99,
    transform: "translate(-23.01 53.14) rotate(-23.59)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.05,88.48s-1.76,4.19-6.85,1.52",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.33,91.33a7.19,7.19,0,0,1-3.33-.94.44.44,0,1,1,.41-.78,5.16,5.16,0,0,0,4.14.63,3.92,3.92,0,0,0,2.09-1.93.44.44,0,1,1,.81.34,4.71,4.71,0,0,1-2.59,2.42A4.32,4.32,0,0,1,113.33,91.33Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.08,124.85s11.22,31.28,19,27.61c3.37-1.59,19.32-26.38,19.86-26.89,1.09-1.06,2.68-.93,3.7-2a7.81,7.81,0,0,0,1.25-2c.55-1.07,1.06-2.5.24-3.38-.17-.17-.39-.34-.38-.58s.23-.37.43-.49l1.35-.78c.31-.18.67-.48.58-.82s-.64-.41-1-.33c-3.82.78-8.3,3.27-11.59,5.23a24.62,24.62,0,0,0,.39-3.09c0-.81-.14-1.86-.94-2s-1.33.71-1.63,1.44c-1.55,3.7-2.51,6.6-4.94,9.82s-5,6.58-7.5,9.86c-1.3-.21-8.09-16.61-8.09-16.61",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.74,153.22a4.27,4.27,0,0,1-1.63-.35C138.6,149.76,130,126,129.65,125a.47.47,0,0,1,.28-.59.46.46,0,0,1,.58.28c.09.24,8.81,24.37,16,27.33a2.86,2.86,0,0,0,2.41,0c2.5-1.18,12.87-16.66,17.3-23.26,1.84-2.76,2.29-3.42,2.43-3.55a5.27,5.27,0,0,1,2-1.09,4.06,4.06,0,0,0,1.68-.89,7.52,7.52,0,0,0,1.17-1.83c.7-1.37.8-2.34.3-2.86l-.07-.08a1,1,0,0,1,.23-1.7l1.35-.79c.28-.16.36-.28.37-.31a1.13,1.13,0,0,0-.5,0c-3.71.75-8.07,3.16-11.45,5.17a.44.44,0,0,1-.49,0,.45.45,0,0,1-.19-.45,25.71,25.71,0,0,0,.39-3c0-.52-.07-1.44-.58-1.53s-1,.87-1.12,1.17c-.26.6-.49,1.18-.72,1.75a33.08,33.08,0,0,1-4.27,8.16q-3.74,5-7.51,9.87a.46.46,0,0,1-.44.17c-1.34-.22-5.86-10.67-8.43-16.88a.45.45,0,0,1,.25-.6.44.44,0,0,1,.59.25c2.94,7.1,6.42,14.69,7.59,16.13,2.41-3.15,4.83-6.31,7.22-9.49a32.39,32.39,0,0,0,4.15-8l.72-1.76c.53-1.26,1.29-1.87,2.14-1.71,1.06.2,1.38,1.41,1.32,2.48a21.37,21.37,0,0,1-.24,2.18c3.3-1.94,7.35-4.07,10.89-4.79.79-.16,1.4.1,1.56.65.08.29.08.84-.79,1.34l-1.35.79a.77.77,0,0,0-.21.15s.11.06.16.11l.1.1c1.19,1.26.17,3.25-.16,3.9A8.12,8.12,0,0,1,173,123.9a4.76,4.76,0,0,1-2,1.11,4.33,4.33,0,0,0-1.7.89c-.13.15-1.14,1.65-2.31,3.4-7.75,11.57-15.26,22.44-17.66,23.58A3.66,3.66,0,0,1,147.74,153.22Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 89.12,
    y1: 152.03,
    x2: 91.04,
    y2: 110.62,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.12,152.49h0a.47.47,0,0,1-.44-.48l1.92-41.41a.5.5,0,0,1,.48-.44.47.47,0,0,1,.44.48l-1.92,41.41A.47.47,0,0,1,89.12,152.49Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 127.92,
    y1: 118.6,
    x2: 124.47,
    y2: 110.62,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.92,119.06a.48.48,0,0,1-.42-.28l-3.45-8a.46.46,0,0,1,.24-.6.45.45,0,0,1,.6.24l3.45,8a.45.45,0,0,1-.24.6A.53.53,0,0,1,127.92,119.06Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.94,245.81s-7.46-4.13-10.61,0a19.14,19.14,0,0,0-3.44,9.41s15.7,2.62,15.82,0S92.94,245.81,92.94,245.81Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.67,
    y: 103.47,
    width: 116.23,
    height: 37.15,
    rx: 5.55,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.34,141.08H170.22a6,6,0,0,1-6-6V109a6,6,0,0,1,6-6H275.34a6,6,0,0,1,6,6v26A6,6,0,0,1,275.34,141.08ZM170.22,103.93a5.11,5.11,0,0,0-5.1,5.1v26a5.11,5.11,0,0,0,5.1,5.1H275.34a5.11,5.11,0,0,0,5.1-5.1V109a5.11,5.11,0,0,0-5.1-5.1Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.09,
    y: 112.63,
    width: 16.72,
    height: 18.83,
    fill: "#FF663B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.27,
    y: 114.88,
    width: 59.55,
    height: 4.93,
    rx: 2.46,
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.27,
    y: 124.29,
    width: 41.8,
    height: 4.93,
    rx: 2.46,
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.25,
    y: 170.51,
    width: 73.58,
    height: 37.15,
    rx: 3.85,
    transform: "translate(-46.11 30.24) rotate(-15.1)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.07,216.19A4.33,4.33,0,0,1,58.92,213l-7.67-28.43a4.31,4.31,0,0,1,3-5.28l63.6-17.16a4.31,4.31,0,0,1,5.28,3l7.67,28.43a4.3,4.3,0,0,1-3,5.28L64.2,216A4.45,4.45,0,0,1,63.07,216.19ZM119,162.89a3.33,3.33,0,0,0-.88.12l-63.6,17.16a3.39,3.39,0,0,0-2.39,4.16l7.67,28.43a3.35,3.35,0,0,0,1.58,2.06,3.42,3.42,0,0,0,2.58.34L127.56,198h0a3.39,3.39,0,0,0,2.06-1.59,3.35,3.35,0,0,0,.33-2.57l-7.67-28.44A3.4,3.4,0,0,0,119,162.89Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.54,
    y: 185.38,
    width: 16.72,
    height: 18.83,
    transform: "translate(-48.22 25.71) rotate(-15.1)",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.86,
    y: 178.66,
    width: 33.29,
    height: 4.93,
    rx: 2.39,
    transform: "translate(-43.71 32.43) rotate(-15.1)",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.43,
    y: 188.62,
    width: 26.58,
    height: 4.93,
    rx: 2.14,
    transform: "translate(-46.33 32.57) rotate(-15.1)",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.72,122.58s-10.86,26-9.74,29S78.3,173.28,78.3,173.28s3.3,10.21,7.75,7.84c2.87-1.52,1.36-10.3,1.36-10.3l3.28-.88s-5.39-2.23-6-3.3-6.4-17-6.4-17l9.94-23.46",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.71,181.94a3.38,3.38,0,0,1-1.23-.25c-3.23-1.31-5.38-7.54-5.6-8.22-.74-1.23-11.21-18.76-12.32-21.72s8.62-26.66,9.74-29.34a.46.46,0,0,1,.6-.25.47.47,0,0,1,.25.6c-4.34,10.39-10.51,26.59-9.74,28.67,1.1,2.92,12.17,21.43,12.28,21.62a.36.36,0,0,1,0,.09c0,.07,2.14,6.51,5.09,7.7a2.25,2.25,0,0,0,2-.12c2.11-1.12,1.52-7.47,1.12-9.82a.47.47,0,0,1,.33-.52l2-.54c-1.72-.76-4.51-2.1-5-3-.61-1.09-6.19-16.37-6.43-17a.45.45,0,0,1,0-.34L87.82,126a.46.46,0,0,1,.84.36l-9.87,23.29c1.65,4.53,5.84,15.89,6.31,16.73.33.58,3.19,2,5.76,3.1a.45.45,0,0,1,.29.45.47.47,0,0,1-.34.41l-2.88.78c.29,1.93,1.13,8.88-1.66,10.37A3.37,3.37,0,0,1,84.71,181.94Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.5,242.47l-3.95,5.12L121.63,245l-.55,6.73s27.46,5.66,28.58,2.63S138.5,242.47,138.5,242.47Z",
    fill: "#231f20"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileArt);
export default __webpack_public_path__ + "static/media/profile_art.71df49f1a17f727708258d391c86fcc5.svg";
export { ForwardRef as ReactComponent };